module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-ap@2x-610d640eaef3772cd4fbc36277c568ef.png";